<template>
	<div>
		<div class="about_us">
			<img class="about_img" src="../assets/img/index/黑色背景图2.jpg" alt='About Us' />
			<div class="eg_about">About <span style="color: #fff;">Us</span>
			</div>
			<div class="cn_about">关于康和达</div>
			<div class="content">
				<div>康和达是一家聚焦生命科学领域实验室设备的公司，为客户提供细胞研究的高端设备，</div>
				<div>主营自动细胞计数仪、活细胞成像分析仪及相关耗材。</div>
				<div>借助自动化设备帮助客户简化细胞研究操作，提高相关效率，让您的细胞研究更简单！</div>
			</div>
		</div>
		<div id="title" class="contact_title">我们的位置
			&nbsp;<span class="dot">·</span>&nbsp;
			<span class="eng_contact_title">Our Location</span>
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="baidu_map">
			<div class="map_group">
				<!-- 上海 -->
				<baidu-map class="map" :center="shanghai.position" :zoom="19" :scroll-wheel-zoom="true"
					@ready="handleMapReady">
					<bm-scale anchor="BMAP_ANCHOR_BOTTON_LEFT"></bm-scale>
					<bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
						anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
					<bm-marker :position="shanghai.position" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
					<bm-info-window :position="shanghai.windowPosition" :title="shanghai.title" :show="shanghai.show"
						@close="shanghai.show = false" @open="shanghai.show = true">
						<p v-text="shanghai.address"></p>
					</bm-info-window>
				</baidu-map>
				<!-- 苏州：坐标由百度地址解析在运行时取得，解析成功后才渲染 -->
				<baidu-map v-if="suzhou.position" class="map" :center="suzhou.position" :zoom="19"
					:scroll-wheel-zoom="true">
					<bm-scale anchor="BMAP_ANCHOR_BOTTON_LEFT"></bm-scale>
					<bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
						anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
					<bm-marker :position="suzhou.position" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
					<bm-info-window :position="suzhou.windowPosition" :title="suzhou.title" :show="suzhou.show"
						:width="260" @close="suzhou.show = false" @open="suzhou.show = true">
						<p>江苏省苏州市虎丘区富春江路188号<br>医疗器械产业园加速器1号楼1004室</p>
					</bm-info-window>
				</baidu-map>
				<div v-else class="map map_placeholder">{{ suzhou.tip }}</div>
			</div>
		</div>
		<!-- #demo_form 是「申请试用」按钮的跳转锚点 -->
		<div id="demo_form">
			<div id="title" class="contact_title2">样机试用申请
				&nbsp;<span class="dot">·</span>&nbsp;
				<span class="eng_contact_title">Demo Application</span>
			</div>
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div id="title" class="form">
			<el-card class="box-card">
				<div class="form_layout">
					<!-- 左栏：申请说明与流程 -->
					<div class="form_intro">
						<p class="intro_title">请填写您的信息</p>
						<p class="intro_eng">Your Information</p>
						<div class="intro_line"></div>
						<p class="intro_desc">填写右侧表单，我们将在 1 个工作日内安排专人与您联系，
							为您匹配合适的机型并安排样机演示。</p>
						<ul class="intro_steps">
							<li><span class="step_no">01</span>提交需求</li>
							<li><span class="step_no">02</span>专人对接</li>
							<li><span class="step_no">03</span>样机演示</li>
						</ul>
						<div class="intro_contact">
							<p><i class="el-icon-phone-outline"></i>181-1812-8515</p>
							<p><i class="el-icon-message"></i>info@kaltec.cn</p>
						</div>
					</div>
					<!-- 右栏：表单 -->
					<div class="form_fields">
						<el-form ref="form" :model="form" label-width="90px">
							<el-form-item label="客户名称" prop="customerName">
								<el-input v-model="form.customerName" prefix-icon="el-icon-user"
									placeholder="请填写您的姓名或单位名称"></el-input>
							</el-form-item>
							<el-form-item label="联系方式" prop="tel">
								<el-input v-model="form.tel" prefix-icon="el-icon-phone-outline"
									placeholder="便于我们与您联系的手机号或邮箱"></el-input>
							</el-form-item>
							<el-form-item label="意向设备" prop="deviceModel">
								<el-input v-model="form.deviceModel" prefix-icon="el-icon-cpu"
									placeholder="如 Celloger Pro、Facscope B，可填多个"></el-input>
							</el-form-item>
							<el-form-item label="其他需求" prop="otherNeed">
								<el-input type="textarea" v-model="form.otherNeed" resize="none" :maxlength="500"
									show-word-limit :autosize="{ minRows: 4, maxRows: 4}"
									placeholder="您的实验场景、样本类型，或其他希望我们了解的信息"></el-input>
							</el-form-item>
							<el-form-item class="form_actions">
								<el-button class="submit_btn" @click="submit">提交申请</el-button>
								<el-button @click="resetForm('form')" class="reset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-card>
		</div>
		<div id="title" class="contact_title">联系我们
			&nbsp;<span class="dot">·</span>&nbsp;
			<span class="eng_contact_title">Contact Us</span>
		</div>
		<SectionDivider class="progress" id="title"></SectionDivider>
		<div class="contact_us">
			<div class="address_list">
				<div class="address_item">
					<span class="pin_wrap">
						<svg class="pin_icon" viewBox="0 0 24 24" aria-hidden="true">
							<path class="pin_body" d="M12 21.5s7-5.8 7-11.5a7 7 0 1 0-14 0c0 5.7 7 11.5 7 11.5z" />
							<circle class="pin_dot" cx="12" cy="10" r="2.6" />
						</svg>
					</span>
					<div>
						<p class="address_city">上海</p>
						<p class="address_detail">上海市奉贤区星火开发区莲塘路251号8幢</p>
					</div>
				</div>
				<div class="address_item">
					<span class="pin_wrap">
						<svg class="pin_icon" viewBox="0 0 24 24" aria-hidden="true">
							<path class="pin_body" d="M12 21.5s7-5.8 7-11.5a7 7 0 1 0-14 0c0 5.7 7 11.5 7 11.5z" />
							<circle class="pin_dot" cx="12" cy="10" r="2.6" />
						</svg>
					</span>
					<div>
						<p class="address_city">苏州</p>
						<p class="address_detail">江苏省苏州市虎丘区富春江路188号医疗器械产业园加速器1号楼1004室</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios"
	import SectionDivider from '../components/public/SectionDivider.vue'
	export default {
		name: 'ContactUs',
		components: {
			SectionDivider
		},
		data() {
			return {
				shanghai: {
					title: '上海康和达生物技术有限公司',
					address: '上海市奉贤区星火开发区莲塘路251号8幢',
					position: { lng: 121.550333, lat: 30.852953 },
					// 信息窗略微上移，避免压住标记
					windowPosition: { lng: 121.550433, lat: 30.853103 },
					show: true
				},
				suzhou: {
					title: '康和达生物（苏州）',
					address: '江苏省苏州市虎丘区富春江路188号医疗器械产业园加速器1号楼1004室',
					// 坐标不写死，由 handleMapReady 中的地址解析填入
					position: null,
					windowPosition: null,
					show: true,
					tip: '苏州地图加载中…'
				},
				form: {
					customerName: '',
					tel: '',
					deviceModel: '',
					otherNeed: ''
				},
			}
		},
		methods: {
			submit() {
				this.$message({
					message: '提交成功，我们会尽快派专人联系您！',
					type: 'success',
				})
				axios.post("/info/customerInfo", this.form)
				/* 				.then((resp) => {

								}); */
			},
			// 苏州地址没有现成坐标，借上海地图 ready 时拿到的 BMap 做地址解析，
			// 避免写死不准确的经纬度；解析成功后右侧地图才会渲染
			handleMapReady({ BMap }) {
				new BMap.Geocoder().getPoint(this.suzhou.address, (point) => {
					if (!point) {
						this.suzhou.tip = '苏州地图加载失败'
						console.warn('[ContactUs] 苏州地址解析失败')
						return
					}
					this.suzhou.position = { lng: point.lng, lat: point.lat }
					// 信息窗略微上移，避免压住标记
					this.suzhou.windowPosition = { lng: point.lng, lat: point.lat + 0.00015 }
				}, '苏州市')
			},
			resetForm(form) {
				this.$refs[form].resetFields();
				/* 				window.onscroll = function() {
								console.info(window.scrollY);
								} 获取当前滚动位置*/
			}
		}
	}
</script>

<style scoped>
	#title {
		margin-left: calc(50% - 600px);
	}

	/* ===== 地址区（原黄底 banner，现改为无背景图的地址展示） ===== */
	.contact_us {
		display: flex;
		justify-content: center;
		margin: 6vh 30px 10vh;
	}

	.address_list {
		display: flex;
		justify-content: center;
		column-gap: 80px;
		row-gap: 45px;
		flex-wrap: wrap;
	}

	.address_item {
		display: flex;
		align-items: flex-start;
		max-width: 460px;
	}

	.pin_wrap {
		flex: none;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 14px;
	}

	/* 地址图标用内联 SVG，任意尺寸下都清晰，颜色跟随文字 */
	.pin_icon {
		width: 30px;
		height: 30px;
		margin-top: 2px;
	}

	/* 实心品牌黄 + 深色描边：纯描边的黄色在白底上过淡 */
	.pin_body {
		fill: #fff100;
		stroke: rgb(35, 24, 21);
		stroke-width: 1.4;
		stroke-linejoin: round;
	}

	.pin_dot {
		fill: #fff;
		stroke: rgb(35, 24, 21);
		stroke-width: 1.4;
	}

	.address_city {
		font-size: 20px;
		font-weight: bold;
		color: rgb(35, 24, 21);
		margin: 2px 0 14px;
	}

	.address_detail {
		font-size: 18px;
		line-height: 2.1;
		color: #555;
		margin: 0;
	}

	.form {
		margin-top: 6vh;
		margin-bottom: 6vh;
	}

	.box-card {
		width: 70%;
		min-height: 450px;
		border-top: 4px solid #fff100;
		overflow: hidden;
		transition: box-shadow .3s;
	}

	.box-card:hover {
		box-shadow: 0 4px 24px rgba(35, 24, 21, .15);
	}

	/* 卡片内边距归零，改由左右两栏各自控制留白，深色左栏才能满溢到卡片边缘 */
	.box-card >>> .el-card__body {
		padding: 0;
	}

	.baidu_map {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 1000px;
		transform: translateY(-100px);
	}

	/* 两张地图并排，总宽仍为 1200px，保持原有版心与外层高度不变 */
	.map_group {
		display: flex;
		justify-content: center;
		gap: 20px;
	}

	.map {
		width: 590px;
		height: 618px;
	}

	.map_placeholder {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f5f5f5;
		color: #999;
		font-size: 16px;
	}

	.about_img {
		width: 100%;
		height: 576px;
	}

	.about_us {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;
	}

	.eg_about {
		margin-bottom: 370px;
		margin-right: 270px;
		transform: translate(50%, 50%);
		position: absolute;
		color: #FFF100;
		font-size: 60px
	}

	.cn_about {
		margin-bottom: 220px;
		margin-right: 200px;
		transform: translate(50%, 50%);
		position: absolute;
		color: #fff;
		font-size: 40px;
	}

	.content {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		position: absolute;
		color: #fff;
		font-size: 20px;
		margin-top: 80px;
		letter-spacing: 1px;
		line-height: 2rem;
	}

	.reset {
		width: 200px;
	}

	.contact_title {
		font-size: 2em;
		margin-top: 10vh;
		letter-spacing: 1px;
	}

	.dot {
		font-weight: 600;
	}

	.eng_contact_title {
		font-family: Rany;
		font-weight: 500;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 20px;
	}

	.contact_title2 {
		font-size: 2em;
		letter-spacing: 1px;
		margin-top: -200px;
	}

	/* ===== 表单卡片：左栏说明 + 右栏表单 ===== */
	.form_layout {
		display: flex;
		align-items: stretch;
	}

	.form_intro {
		flex: 0 0 34%;
		background-color: rgb(35, 24, 21);
		color: #fff;
		padding: 45px 35px;
		box-sizing: border-box;
	}

	.intro_title {
		font-size: 26px;
		font-weight: bold;
		margin: 0;
	}

	.intro_eng {
		font-family: Rany;
		font-size: 16px;
		color: #fff100;
		letter-spacing: 1px;
		margin: 6px 0 0;
	}

	.intro_line {
		width: 50px;
		height: 3px;
		background-color: #fff100;
		margin: 18px 0 22px;
	}

	.intro_desc {
		font-size: 15px;
		line-height: 2;
		color: #e0dcda;
		margin: 0;
	}

	.intro_steps {
		list-style: none;
		padding: 0;
		margin: 30px 0 0;
	}

	.intro_steps li {
		display: flex;
		align-items: center;
		font-size: 15px;
		margin-bottom: 14px;
	}

	.step_no {
		font-family: Rany Bold;
		font-size: 18px;
		color: #fff100;
		margin-right: 12px;
	}

	.intro_contact {
		margin-top: 35px;
		padding-top: 22px;
		border-top: 1px solid rgba(255, 255, 255, .15);
	}

	.intro_contact p {
		display: flex;
		align-items: center;
		font-size: 15px;
		margin: 0 0 10px;
	}

	.intro_contact i {
		color: #fff100;
		font-size: 17px;
		margin-right: 10px;
	}

	.form_fields {
		flex: 1;
		min-width: 0;
		padding: 45px 40px;
		box-sizing: border-box;
	}

	/* 输入框跟随右栏宽度，不再写死像素/vw */
	.form_fields >>> .el-input__inner,
	.form_fields >>> .el-textarea__inner {
		width: 100%;
	}

	/* Element 默认聚焦色为蓝色，改为品牌黄 */
	.form_fields >>> .el-input__inner:focus,
	.form_fields >>> .el-textarea__inner:focus {
		border-color: #fff100;
	}

	.form_fields >>> .el-input__inner:hover,
	.form_fields >>> .el-textarea__inner:hover {
		border-color: #d9cf00;
	}

	.form_fields >>> .el-form-item__label {
		color: rgb(35, 24, 21);
		font-weight: 500;
	}

	.form_actions {
		margin-bottom: 0;
	}

	/* 按钮行横向排布，空间不足时由提交按钮收缩，重置不会被挤到下一行 */
	.form_actions >>> .el-form-item__content {
		display: flex;
		align-items: center;
	}

	/* Element 相邻按钮默认的 10px 外边距改由这里统一控制 */
	.form_actions >>> .el-button + .el-button {
		margin-left: 12px;
	}

	.form_actions >>> .el-button {
		white-space: nowrap;
	}

	.submit_btn {
		flex: 1 1 auto;
		min-width: 110px;
		max-width: 180px;
		background-color: #fff100;
		border-color: #fff100;
		color: rgb(35, 24, 21);
		font-weight: bold;
	}

	.reset {
		flex: 0 0 auto;
	}

	.submit_btn:hover, .submit_btn:focus {
		background-color: #ffee33;
		border-color: #ffee33;
		color: rgb(35, 24, 21);
	}

	@media screen and (max-width: 1150px) {
		#title {
			margin-left: calc(50% - 450px);
		}

		.about_img {
			height: calc(300px + 10vw);
			width: 100%;
		}

		.eg_about {
			margin-bottom: 280px;
			margin-right: 210px;
			font-size: 2.5rem
		}

		.cn_about {
			margin-bottom: 170px;
			margin-right: 200px;
			font-size: 2rem;
		}

		.content {
			font-size: 1.1rem;
			margin-top: 80px;
			letter-spacing: 1px;
		}

		.baidu_map {
			width: 100%;
			height: 800px;
		}

		.map_group {
			gap: 15px;
		}

		.map {
			width: 393px;
			height: 500px;
		}

		.box-card {
			width: 80%;
			min-height: 450px;
			margin-left: 50px;
		}

		.form_intro {
			padding: 35px 25px;
		}

		.form_fields {
			padding: 35px 25px;
		}

		.reset {
			display: none;
		}

		.address_list {
			column-gap: 40px;
		}

		.address_item {
			max-width: 400px;
		}
	}

	@media screen and (max-width: 800px) {
		#title {
			margin-left: calc(50% - 170px);
		}

		.about_img {
			height: calc(200px + 10vw);
			width: 100%;
		}

		.eg_about {
			font-size: 1rem;
			margin-bottom: 100px;
			margin-right: 70px;
		}

		.cn_about {
			font-size: 1rem;
			margin-bottom: 50px;
			margin-right: 85px;
		}

		.content {
			font-size: 0.4rem;
			line-height: 1rem;
			margin-bottom: 20px;
			letter-spacing: 0;
		}

		.baidu_map {
			width: 100%;
			height: auto;
			transform: translateY(0);
			margin-top: 2rem;
		}

		/* 窄屏两张地图上下排列 */
		.map_group {
			flex-direction: column;
			gap: 15px;
		}

		.map {
			width: 360px;
			height: 320px;
		}

		.contact_title {
			font-size: 1.1rem;
			margin-top: 6vh;
			letter-spacing: 1px;
		}

		.eng_contact_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.contact_title2 {
			font-size: 1.1rem;
			letter-spacing: 1px;
			margin-top: 6vh;
		}

		.form {
			margin-top: 6vh;
			margin-bottom: 6vh;
		}
		.box-card {
			width: 360px;
			min-height: 470px;
			transform: translateX(-60px);
		}

		/* 窄屏改为上下堆叠：说明在上，表单在下 */
		.form_layout {
			flex-direction: column;
		}

		.form_intro {
			flex: none;
			padding: 30px 25px;
		}

		.intro_title {
			font-size: 20px;
		}

		.intro_desc {
			font-size: 14px;
		}

		/* 窄屏下省略流程步骤，避免卡片过长 */
		.intro_steps {
			display: none;
		}

		.intro_contact {
			margin-top: 22px;
			padding-top: 18px;
		}

		.form_fields {
			padding: 30px 25px;
		}

		.form_fields >>> .el-form-item__label {
			font-size: 13px;
		}

		.submit_btn {
			max-width: 150px;
		}

		.contact_us {
			margin: 4vh 20px 6vh;
		}

		/* 窄屏两个地址上下排列 */
		.address_list {
			flex-direction: column;
			row-gap: 35px;
		}

		.pin_wrap {
			margin-right: 10px;
		}

		.pin_icon {
			width: 24px;
			height: 24px;
			margin-top: 1px;
		}

		.address_city {
			font-size: 17px;
			margin: 1px 0 10px;
		}

		.address_detail {
			font-size: 15px;
			line-height: 2;
		}
	}
</style>